import StaticAnalysis from "./StaticAnalysis.model";
import { staticLayerTypes } from ".";

/**
 * EventTotals model is based on the event count analysis in the static entity analysis
 * This model defines an analysis which requires an event assosicated with a static entity
 * or events happening around a static entity within a specified radius.
 */
export default class EventTotals extends StaticAnalysis {
  /**
   *
   * @param {Object} data
   * @param {String} data.id id of the analysis
   * @param {String} data.name Name of the analysis
   * @param {Object} data.static_entity staticEntity meta data
   * @param {Object} data.entity Entity object
   * @param {Object} data.event Event object
   * @param {Number} data.radius Radis filter in meters
   */
  constructor({ id, name, static_entity, event, entity, radius }) {
    super({ type: staticLayerTypes.EVENT_TOTALS, id, name, static_entity });
    this.entity = entity;
    this.event = event;
    this.radius = radius;
    this.component = "EventTotalsLayer";
  }
}
